/* eslint-disable */
import React, { FC, useState, useEffect, useRef } from 'react';
import withLocalization from '../hoc/withLocalization';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { subtractDollarValues } from '../../util/CommonLogic';
import { replacePlaceholder, calculateMonthsUntilUpcomingDate, removeDecimalPart } from '../../util/CommonLogic';
import { logAnalyticData, offerType } from '../../analytics';
import ParseHtml from '../common/ParseHtml';
import { getPaymentTypeFromToken } from '../NewOfferCyberSource/paymentUtil';
import { getSiteIdentifier } from '../../util/SiteDetails';
import isAsia from '../../util/isAsia';
import './ThankYouDetailsPage.scss';

interface ReservationPanelProps {
  localize?: any;
  localizeImages?: any;
}
const ThankYouDetailsPage: FC<ReservationPanelProps> = (props: ReservationPanelProps) => {
  const { localize, localizeImages } = props;
  const htmlContainerRef = useRef(null);
  const prospectDetails: any = useSelector((state: RootState) => state.offerDetails.prospect);
  const bookingConfirmation: any = useSelector((state: RootState) => state.newOfferPaymentDetails.confirmationDetails);
  const whatsAppPath = localizeImages('preview-sales-engine.static-content.images.whatsapp-logo', 0, '5:1');
  const isPinOptFlow: boolean = useSelector((state: RootState) => state.pinOptFlowDetails.pinOptFLow);
  const pinOfferDetails: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const newOfferData = pinOfferDetails;

  const urlParams = useSelector((state: RootState) => state.pinOptFlowDetails.urlData);
  const pinInfoDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinDetails);
  const pin = pinInfoDetails?.pin || '';
  const defaultChatLinkText = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-chat-link')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-chat-link');
  const phNo = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-phone-number')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-phone-number');
  const callCenterCode = prospectDetails?.callCenterCode || '';
  const jahiaKey = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.chat-link`;
  const jahiaCallcenter = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.activationPhone`;

  const callCenterPhoneWithCode = localize(jahiaCallcenter) || phNo;
  const sanitizedPhoneDigit = callCenterPhoneWithCode.replace(/[^\d+]/g, '');

  const chatLinkText: any = localize(jahiaKey) || defaultChatLinkText;

  const pinLeadDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinOptFlowLeadInfo);
  const offerDetails = (newOfferData?.offers && newOfferData?.offers[0]) || {};
  const roomType: any = (offerDetails?.roomTypes && offerDetails?.roomTypes[0]) || {};
  const retailVal = offerDetails?.retailValue || '';
  const retailPrice = roomType?.highSeasonRetailPrice || '';
  const updatedRetPrice = retailPrice || retailVal;
  const splitRetVal = updatedRetPrice?.split('$') || '';
  const refineRetPrice = removeDecimalPart(splitRetVal[1]) || '';
  const pinPospectInfo: any = useSelector((state: RootState) => state.offerDetails.prospect) || '';
  const transientToken = useSelector((state: RootState) => state.newOfferPaymentDetails.transientToken);

  const pinEmail = pinPospectInfo?.email || pinLeadDetails?.email;
  //const dialCode = useCountryCodeByName(pinPospectInfo?.countryCode);
  const dialCode = pinLeadDetails?.dialCode || '';
  const dailCodeWithPhone = `${dialCode}${pinLeadDetails?.phone}`;
  const pinPhNo = pinPospectInfo?.phone || dailCodeWithPhone;

  const finalMail = pinEmail;
  const finalPhone = pinPhNo;

  const getOfferType: any = sessionStorage.getItem('offer-type');
  const isPaid = getOfferType === 'paid' ? true : false;
  const loc = (newOfferData?.offers && newOfferData?.offers[0]?.loc) || '';

  //const stPhone = localize('preview-sales-engine.static-content.copy.pbeo.default-activation-phone');
  const stPhone = `+${callCenterPhoneWithCode}`;
  const difDates = calculateMonthsUntilUpcomingDate(offerDetails?.finalDate);
  const totalMonths: any = difDates || '';
  const thankHedDec = localize(
    'preview-sales-engine.static-content.copy.pbeo.intl.intl-confirmation-page-full-pay-description',
  );
  const updatedContent = replacePlaceholder(
    thankHedDec,
    '{0}.',
    `<span class="header-mail-wrapper">${finalMail}</span>`,
  );
  const confirmationDataContent = `${localize(
    'preview-sales-engine.static-content.copy.pbeo.confirmation-number-text',
  )} `;
  const confirmationMessage = replacePlaceholder(
    confirmationDataContent,
    ':',
    `: <span class="header-phone-wrapper">${finalPhone}</span>`,
  );
  const stphoneTag = `<a class="textHeaderLinkWraper" href="tel:${stPhone}">${stPhone}</a>`;
  const step1 = `${localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-what-happens-step-1-text')}`;
  const step2 = `${localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-what-happens-step-2-text')}`;
  const updatedMonth = replacePlaceholder(step2, '{0}', totalMonths);
  const updatedStep2 = updatedMonth?.replaceAll(`{1}`, stPhone);
  const handleClickChatLink = (e: any) => {
    e.preventDefault();
    window.open(chatLinkText, '_blank');
  };
  const whatsAppImg = chatLinkText
    ? `<span><a href="#" data-chat-link="true"  ><img class="app-thank-img" alt="whatsapp" src="${whatsAppPath?.path}"></a></span>`
    : '';
  //const step2AppData = replacePlaceholder(updatedStep2, '</a></span>', whatsAppImg);
  const removeLinkData = chatLinkText ? `{2}` : `or {2}`;
  const step2AppData = replacePlaceholder(updatedStep2, removeLinkData, whatsAppImg);
  const refineStep2 = replacePlaceholder(step2AppData, 'textHeaderLinkWraper', 'OrderSummaryNumWraper');

  const step3 = `${localize('preview-sales-engine.static-content.copy.pbeo.intl.intl-what-happens-step-3-text')}`;

  const updatedStep3 = replacePlaceholder(step3, `begin!</span></div>\n\n`, `begin!</span>`);
  const refineStep3 = `${updatedStep3} </div>`;
  const siteIdentifier = getSiteIdentifier();
  useEffect(() => {
    const container: any = htmlContainerRef.current;

    const handleClick = (e: any) => {
      const target = e.target.closest('a[data-chat-link]');
      if (target && container.contains(target)) {
        handleClickChatLink(e);
      }
    };

    container.addEventListener('click', handleClick);
    return () => container.removeEventListener('click', handleClick);
  }, []);
  useEffect(() => {
    const roomType = (offerDetails?.roomTypes && offerDetails?.roomTypes[0]) || {};
    const stateCode = roomType?.property?.stateCode;
    const flowIdentifier = isPinOptFlow ? 'pin' : isPaid ? 'paid' : 'organic';
    const destination = urlParams?.destination;
    const brand = urlParams?.brand && urlParams?.brand.length > 0 ? urlParams?.brand : roomType?.property?.brandName;
    const offerCode = offerDetails?.offerCode || 'Vacation Offer';

    const paymentType: any = transientToken ? getPaymentTypeFromToken(transientToken) : '';
    //const paymentType = getPaymentTypeFromToken(transientToken);
    window.dataLayer.push({ ecommerce: null });
    const pushToDataLayer = () => {
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          transaction_id: pin,
          currency: 'USD',
          value: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
          payment_type: paymentType.text,
          items: [
            {
              item_id: roomType?.property?.marshaCode,
              item_name: roomType?.property?.name,
              item_brand: brand,
              item_category: destination,
              item_category2: loc,
              item_category3: roomType?.property?.country || '',
              item_category4: stateCode,
              item_category5: roomType?.property?.city,
              item_category6: pinPospectInfo?.stateProvince,
              item_category7: offerType(offerDetails),
              item_category8: offerCode,
              item_category9: pin,
              price: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
              retail_price: refineRetPrice?.replace(/[$,]/g, '') || '',
              package_price: roomType?.startingCost?.replace(/[$,]/g, '') || '',
              flow_identifier: flowIdentifier,
              quantity: 1,
            },
          ],
        },
      });
    };
    pushToDataLayer();
    logAnalyticData(
      {
        event: 'PbeConfirmation',
        siteSection: 'MVC ' + siteIdentifier + 'Optimized PBE',
        pageName: 'MVC ' + siteIdentifier + '| PBE Confirmation',
        pageHierarchy: '',
        server: 'MVC',
        website: 'MVC react',
        language: 'en',
      },
      {
        formLOC: loc,
        destination: destination,
        resortCity: roomType?.property?.city,
        resortState: roomType?.property?.stateCode,
        resortCountry: roomType?.property?.country || '',
        resortName: roomType?.property?.name,
        resortBrand: brand,
        offerCode: offerCode,
        offerType: offerType(offerDetails),
        flowIdentifier: flowIdentifier,
        retailPrice: refineRetPrice?.replace(/[$,]/g, '') || '',
        packagePrice: roomType?.startingCost?.replace(/[$,]/g, '') || '',
        depositPrice: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
        amountPaid: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
        currency: 'USD',
        quanity: '1',
        resortMarsha: roomType?.property?.marshaCode,
        userSelectedState: pinPospectInfo?.stateProvince,
        bookingStepName: 'MVC ' + siteIdentifier + '| PBE Confirmation',
        paymentType: paymentType.text,
        confirmationNumber: bookingConfirmation?.ConfirmationNumber || '',
      },
    );
  }, []);

  return (
    <>
      <div className="thankYouTopSection">
        <div className="thankYouHeaderSection">
          <span className="thankYou-header-Title">
            {localize('preview-sales-engine.static-content.copy.pbeo.thank-you-success-header')}
          </span>
          <div className="thankyou-header-detail-container">
            <div className="header-mail-section">
              <div>
                <ParseHtml htmlInput={updatedContent}></ParseHtml>
              </div>
            </div>
            <div className="header-phone-section">
              <ParseHtml htmlInput={confirmationMessage}></ParseHtml>
            </div>
          </div>
        </div>
        <div className="thankYou-desc-section">
          <span className="thankYou-desc-header">
            {localize('preview-sales-engine.static-content.copy.pbeo.what-happens-next-section-header')}
          </span>
          <div className="desc-list-container">
            <div className="desc-listItem-sction">
              <ParseHtml htmlInput={step1}></ParseHtml>
            </div>

            <div className="desc-listItem-sction" ref={htmlContainerRef}>
              <ParseHtml htmlInput={refineStep2}></ParseHtml>
            </div>
            <div className="desc-listItem-sction">
              <ParseHtml htmlInput={refineStep3}></ParseHtml>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withLocalization(ThankYouDetailsPage);
